import { render, staticRenderFns } from "./DTooltip.vue?vue&type=template&id=a4cf8768&scoped=true&"
import script from "./DTooltip.vue?vue&type=script&lang=js&"
export * from "./DTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DTooltip.vue?vue&type=style&index=0&id=a4cf8768&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cf8768",
  null
  
)

export default component.exports